export const SPIN_OUTCOME_DEFAULTS: any = {};
